// extracted by mini-css-extract-plugin
module.exports = {"eventInfoIntro":"EventInfoIntro_eventInfoIntro__1cOV5","image":"EventInfoIntro_image__1KkVw","title":"EventInfoIntro_title__1lr8z"};